<template>
  <div class="page-main">
    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <!-- <label style="font-size: large;font-weight: bold;">Buat Picklist (Skema Auto)</label> -->
        <h3>Sinkronisasi Tray / Container</h3>
        <label>Scan tiap tray untuk mencocokan dengan DO yang akan di proses</label>
      </div>
      <div class="col-sm-4">
        <h4>Step 2 / 2</h4>
      </div>
      <hr/>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-sm-5" style="padding-right: 0px;">
        <h4>Total <span id="id-num-tray-left">5</span> Tray / Containers</h4>
        <div class="row">
          <div class="col-sm-8">
            <b-form-input class="tray-input" v-model="tray" placeholder="ID Tray" id="id-tray"></b-form-input>
          </div>
          <div class="col-sm-4">
            <img width="55%" src="./../../assets/scan.jpeg"/>
            <!-- <b-icon icon="search" font-scale="5" scale="2" class="bg-info"></b-icon>
            <b-icon scale="2" font-scale="2" icon="search"></b-icon> -->
          </div>
        </div>

        <h4 class="mt-3">Nomor tray yang di scan sebelumnya: <span id="id-scan-before">13</span></h4>
        <div id="id-tray-scan-error" style="color: red">
          Tray tidak tersedia / teradftar atau sedang di pakai
        </div>
        <div>
          <b-button style="width:90%" size="lg" class="text-center mt-3" variant="info" > Pair </b-button>
        </div>

        <div class="mt-5">
          <!-- <b-button v-b-modal.modal-no-backdrop size="lg" style="width:90%" tabindex="7" -->
          <b-button size="lg" style="width:90%" tabindex="7" @click="showModal"
                    variant="success" class="mr-3">Lihat List DO</b-button>
        </div>
      </div>

      <!-- LIST PAIR DO AND TRAY -->
      <div class="col-sm-7" style="padding-left: 0px;">
        <h4>List Paired DO dan Tray</h4>
        <div style="overflow-y: scroll; height:500px;">
          <div class="row">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-116785</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="12"></b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-116485 ( with Table) </h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <div class="card-text">
                    <table class="tablex">
                      <tr>
                        <td>
                          Total Item: 2
                        </td>
                        <td>
                          <div style="margin-left: 30px;">
                            <!--
                            Total Pcs: X
                            Total Pcs: Y
                            -->
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Total Pcs: 4
                        </td>
                        <td>
                          <div style="margin-left: 30px;">
                            <!--
                            Total Pcs: X
                            Total Pcs: Y
                            -->
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="14">14</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-7">
              <div class="card">
                <h5 class="card-header">DO REF: M1-216485</h5>
                <div class="card-body">
                  <h5 class="card-title">Client: <span>NIRMANA</span></h5>
                  <p class="card-text">
                    Total Item: 2
                    Total Pcs: 4
                  </p>
                  <!-- <a href="#" class="btn btn-primary">Ganti Tray</a> -->
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <b-form-input class="tray-list" placeholder="1446">1446</b-form-input>
            </div>
            <div class="col-sm-1">
              <b-icon icon="check" font-scale="5" scale="1.4" class="bg-success"></b-icon>
              <!-- <b-icon icon="question-circle-fill" font-scale="5" scale="1" aria-label="Help"></b-icon> -->
            </div>
          </div>

        </div>

        <div class="mt-5">
          <b-button size="lg" style="width:30%"
                    variant="secondary" class="mr-3" v-on:click="showModalConfirm">Konfirmasi</b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7 mr-0">
        <!--
        <h4>Nomor tray yang di scan sebelumnya: <span id="id-scan-before"></span></h4>
        <div id="id-tray-scan-error" style="color: red">
          Tray tidak tersedia / teradftar atau sedang di pakai
        </div>
        <div>
          <b-button style="width:100%" size="lg" class="text-center mt-3" variant="info" > Pair </b-button>
        </div>
        -->
      </div>
    </div>

    <!-- <b-modal id="modal-no-backdrop" size="xl" hide-backdrop content-class="shadow" title="Daftar DO"> -->
    <b-modal ref="ref-modal-do" id="modal-no-backdrop"
             @shown="focusCloseDOListElement"
             size="xl" content-class="shadow" title="Daftar DO" hide-footer>
      <p class="my-2">
        List DO yang di populate otomatis oleh <code>system</code>
      </p>
      <table class="table">
        <thead class="table-active">
        <tr>
          <!-- <th class="align-middle text-center"><i class="fas fa-ellipsis-v"></i></th> -->
          <th class="align-middle">Client ID</th>
          <th class="align-middle">DO Reference</th>
          <th class="align-middle">Product Id</th>
          <th class="align-middle">Product Name</th>
          <th class="align-middle">Req Qty</th>
          <th class="align-middle">Tray</th>
        </tr>
        </thead>
        <tbody>
        <!--
        <template v-for="(row, idx) in rows">
          <tr :key="row.id">
            <td :title="idx+1">
              <button class="btn btn-rounded btn-sm"
                      :class="{'btn-primary': selected_data.id != row.id, 'btn-danger': selected_data.id == row.id}"
                      style="padding: 0px 4px !important" @click="toggleDetail(idx)">
                <i class="fa"
                   :class="{'fa-plus': selected_data.id != row.id, 'fa-minus': selected_data.id == row.id}"></i>
              </button>
            </td>
            <td>{{ row.client_id }}</td>
          </tr>
        </template>
        -->
        <tr>
          <td>NIRMANA</td>
          <td>M1-116785</td>
          <td>SUP-NIR-A01-HER-FOO</td>
          <td>Supremasi ME Capsule</td>
          <td>2</td>
          <td></td>
        </tr>
        <tr>
          <td>NIRMANA</td>
          <td>M1-116784</td>
          <td>SUP-NIR-A02-HER-FOO</td>
          <td>Suprema Me 30 Capsule</td>
          <td>2</td>
          <td>12</td>
        </tr>
        <tr>
          <td>NIRMANA</td>
          <td>M1-116285</td>
          <td>SUP-NIR-A02-HER-FOO</td>
          <td>Suprema Me 30 Capsule</td>
          <td>1</td>
          <td></td>
        </tr>
        <tr>
          <td>NIRMANA</td>
          <td>M1-126785</td>
          <td>SUP-NIR-A04-HER-FOO</td>
          <td>VIVASLIM OBAT PELANGSING</td>
          <td>1</td>
          <td>4</td>
        </tr>
        </tbody>
      </table>

      <b-button ref="ref-modal-do-close" class="mt-3" block @click="$bvModal.hide('modal-no-backdrop')">Tutup</b-button>
    </b-modal>

    <b-modal ref="ref-modal-confirm" id="modal-confirm" hide-footer title="Sukses">
      <div class="d-block text-center">
        <h3>Sukses Konfirmasi Picking</h3>
        <p>
          Lanjutkan proses picking sesuai arahan yang diberikan
        </p>
      </div>

      <!--
      <b-button ref="ref-modal-do-close" variant="outline-success" class="mt-3" block
                @click="$bvModal.hide('modal-confirm')">Mengerti</b-button>
      -->
      <b-button ref="ref-modal-do-close" variant="outline-success" class="mt-3" block
                @click="goToDOListPage">Mengerti</b-button>

    </b-modal>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      content: '',
      tray: '',
      selectedOrder: 'multi',
      optionsOrder: [
        { text: 'Single Line', value: 'single' },
        { text: 'Multi Line', value: 'multi' },
      ],
      selectedTray: 12,
      optionsTray: [
        { text: '2 Tray', value: 2 },
        { text: '4 Tray', value: 4 },
        { text: '6 Tray', value: 6 },
        { text: '8 Tray', value: 8 },
        { text: '10 Tray', value: 10 },
        { text: '12 Tray', value: 12 },
        { text: 'Lain-nya', value: 0 },
      ],
      selectedException: 'NOTHING',
      optionsException: [
        { text: 'Tidak Ada', value: 'NOTHING' },
        { text: 'Tidak Ada Expiry Date', value: 'NO_EXPIRY_DATE' },
        { text: 'Tidak Ada Batch', value: 'NO_BATCH' },
      ],
      onCloseConfirm: false,
    };
  },
  methods: {
    goToDOListPage: function() {
      this.$router.push('/do')
    },
    showModal() {
      this.$refs['ref-modal-do'].show()
      //this.$refs['ref-modal-do-close'].focus()
    },
    showModalConfirm() {
      this.$refs['ref-modal-confirm'].show()
    },
    focusCloseDOListElement() {
      this.$refs['ref-modal-do-close'].focus()
    },
  },
  mounted() {
    //this.$refs.typeOrder.$el.focus();
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if ("modal-confirm" === modalId) {
        bvEvent.preventDefault()
        /* eslint-disable no-console */
        //console.log('Modal is about to be hide', bvEvent, modalId)
        /* eslint-enable no-console */
        //this.$refs['ref-modal-confirm'].hide()
        //this.goToDOListPage()
      }
    })
  }
};
</script>

<style scoped>
.tray-input {
  font-size: 4cm;
}
.tray-list {
  font-size: 1.3cm;
}
</style>
